import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const MobileFooter = (props, { config }) => {
  // REIS-195: semantic <footer> element. NB it currently renders inside <main>
  // (MobileView), so it is NOT given role="contentinfo" — a top-level
  // contentinfo landmark would require relocating the footer outside <main>,
  // flagged as a separate layout change.
  return (
    <>
      {config.useCookiesPrompt && (
        <footer className="mobile-footer">
          <div style={{ margin: '15px' }}>
            <div>{config.copyrightText || ''}</div>
            <div>
              <button
                type="button"
                onClick={() =>
                  window.CookieConsent.renew && window.CookieConsent.renew()
                }
              >
                <FormattedMessage
                  id="cookie-settings"
                  default="Cookie settings"
                />
              </button>
            </div>
          </div>
          <div className="mobile-footer-bar-container">
            <div className="mobile-footer-bar" />
          </div>
        </footer>
      )}
    </>
  );
};

MobileFooter.contextTypes = {
  config: PropTypes.object.isRequired,
};

export default MobileFooter;
